<script setup lang="ts">
    import type { HeaderMobileNavItemsProps } from '~/components/mol/HeaderMobileNavItems.vue';
    import type { MenuItem } from '~/graphql/generated';

    interface HeaderMobileNavWrapper {
        menu: HeaderMobileNavItemsProps['menu'];
        menuLevel: number;
        menuLevelTitle: string;
    }

    defineProps<HeaderMobileNavWrapper>();
    const emits = defineEmits<{
        (e: 'back'): void;
        (e: 'open', data: MenuItem): void;
    }>();

    const openLevel = (item: MenuItem) => {
        emits('open', item);
    };
</script>

<template>
    <nav class="atm-header-mobile-nav-wrapper fixed left-0 top-0 z-xl h-[100dvh] w-full max-w-full bg-white pb-14 lg:hidden">
        <div class="h-14 place-content-center border-b border-woom-grey-taupe px-6 drop-shadow">
            <woom-icon-woom-logo
                v-if="menuLevel === 1"
                class="mx-auto h-5 fill-woom-red" />
            <button
                v-else
                :aria-label="$t('cta.menu.back')"
                class="flex h-full w-full items-center justify-between transition-colors hover:text-woom-red focus:text-woom-red"
                @click="emits('back')">
                <div
                    class="font-bold"
                    v-once>
                    <renderer-html :content="woomTextFormat(menuLevelTitle || '')" />
                </div>
                <woom-icon-chevron-left class="h-6 w-6 fill-current" />
            </button>
        </div>
        <div class="h-full max-h-[calc(100dvh-7rem)] overflow-auto px-6">
            <div class="flex h-full flex-col justify-between pt-1.5">
                <mol-header-mobile-nav-items
                    :menu="menu"
                    :menu-level="menuLevel"
                    :open-level="openLevel">
                    <slot></slot>
                </mol-header-mobile-nav-items>
            </div>
        </div>
    </nav>
</template>
